import React, { useState } from "react";

export default function FAQ() {
  const [open, setOpen] = useState(null);

  const faqs = [
    { id: 1, question: "What courses are available?", answer: "We offer six diploma programmes." },
    { id: 2, question: "How do I register?", answer: "Click on 'Register' and fill out the form." },
  ];

  return (
    <div className="container">
      <h1>Frequently Asked Questions</h1>
      <ul>
        {faqs.map((faq) => (
          <li key={faq.id}>
            <button onClick={() => setOpen(open === faq.id ? null : faq.id)}>
              {faq.question}
            </button>
            {open === faq.id && <p>{faq.answer}</p>}
          </li>
        ))}
      </ul>
    </div>
  );
}
